import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class UtilService {
  getFormattedDate(date: string): string {
    let dateArray = date.split('-');
    return dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0];
  }

  getDBFormattedDateString(date: string): string {
    let dateArray = date.split('/');
    return dateArray[2] + '-' + dateArray[0] + '-' + dateArray[1];
  }

  getAge(dob: Date): number {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24 * 365.25;
    let today = new Date();
    const utc1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    const utc2 = Date.UTC(dob.getFullYear(), dob.getMonth(), dob.getDate());
    return Math.floor((utc1 - utc2) / _MS_PER_DAY);
  }

  parseDate(str: string): boolean {
    if (str.trim().length !== 0) {
      const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
      return date_regex.test(str);
    }
    return true;
  }

  getDBFormattedDate(dobModel: NgbDateStruct | undefined): string {
    if (dobModel === undefined) {
      return '1111-01-01';
    }

    return dobModel.year + '-' + dobModel.month + '-' + dobModel.day;
  }

  validateName(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z -]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateNumbers(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[0-9]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateEmail(str: string): boolean {
    if (str.trim().length !== 0) {
      const emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      let value = emailRegex.test(str);
      return value;
    }
    return true;
  }

  validateAddress(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[0-9a-zA-Z - / .]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validatePostalCode(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[0-9a-zA-Z -]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validatePhoneNumbers(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[0-9 + -]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validatePhoneNumberLength(str: string): boolean {
    if (str.trim().length !== 0) {
      let value = str.length > 16 ? true : false;
      return value;
    }
    return false;
  }

  validateCharactersOnly(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z ' .]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateExamIndexNo(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z 0-9 -]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateGrade(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z 0-9+-]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateSubject(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z ]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateOthers(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z ,.''\r\n]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  validateEducationalQualificationOthers(str: string): boolean {
    if (str.trim().length !== 0) {
      const nameRegex = /^[a-zA-Z0-9 !.() & -''\r\n]+$/;
      let value = nameRegex.test(str);
      return value;
    }
    return true;
  }

  internationalPhoneNumberHandler(e: any, contactNo: string): string {
    let phoneNumber = '';

    if (e.dialCode === undefined) {
      console.log(e.dialCode);
    } else if (contactNo === '+') {
      phoneNumber = '';
    } else {
      phoneNumber = '+' + e.dialCode + ' ' + contactNo.substring(contactNo.lastIndexOf(' ') + 1).trim();
    }

    return phoneNumber;
  }
}